import { styled } from "@vitality-ds/system";
import BaseComboButtonStyles from "./styles/BaseComboButton.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseComboButton = styled("div", BaseComboButtonStyles);